/* eslint-disable complexity */
import { North, South } from '@mui/icons-material';
import { Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowBottom from 'assets/images/icons/Print-Arrow-Bottom.svg';
import ArrowLeft from 'assets/images/icons/Print-Arrow-Left.svg';
import ArrowRight from 'assets/images/icons/Print-Arrow-Right.svg';
import ArrowTop from 'assets/images/icons/Print-Arrow-Top.svg';
import React from 'react';

export const getFontSize = type => {
  switch (type) {
    case 'Label2x5':
      return 16;
    case 'Label3x6':
      return 24;
    case 'Label6x3':
      return 24;
    case 'Label5x8':
      return 28;
    case 'Label10x10':
      return 54;
    case 'Label10x15':
      return 78;
    default:
      return 14;
  }
};

const GeneratedArrow = (arrow, type, size) => {
  switch (arrow) {
    case 'top':
      return (
        <img
          src={ArrowTop}
          alt=""
          style={{
            position: type === 'Label10x15' ? 'absolute' : 'unset',
            bottom: 12,
            right: 12,
            width:
              type === 'Label10x15' || type === 'Label10x10'
                ? '48px'
                : type === 'Label5x8'
                ? '28px'
                : type === 'Label3x6' || type === 'Label6x3'
                ? '17px'
                : '14px',
          }}
        />
      );
    case 'bottom':
      return (
        <img
          src={ArrowBottom}
          alt=""
          style={{
            position: type === 'Label10x15' ? 'absolute' : 'unset',
            bottom: 12,
            right: 12,
            width:
              type === 'Label10x15' || type === 'Label10x10'
                ? '48px'
                : type === 'Label5x8'
                ? '28px'
                : type === 'Label3x6' || type === 'Label6x3'
                ? '17px'
                : '14px',
          }}
        />
      );
    case 'Left':
      return (
        <img
          src={ArrowLeft}
          alt=""
          style={{
            width: size || '32px',
          }}
        />
      );
    case 'Right':
      return (
        <img
          src={ArrowRight}
          alt=""
          style={{
            width: size || '32px',
          }}
        />
      );
    case 'none':
      break;
    default:
      break;
  }
};

export default React.forwardRef(({ item, sx }, ref) => {
  if (item.type === 'Label10x15') {
    return (
      <Type5Paper elevation={3} sx={sx}>
        <img src={item.qrCode} width={300} height={300} alt="" />
        <TextsBox>
          {item?.title ? (
            <Typography
              mb={0.5}
              sx={{
                color: '#000',
                fontSize: `${getFontSize(item.type)}px`,
                overflowWrap: 'anywhere',
                textAlign: 'center',
                lineHeight: 1,
              }}
            >
              {item.title}
            </Typography>
          ) : null}
          <Typography
            mb={0}
            sx={{
              color: '#000',
              fontSize: `${getFontSize(item.type)}px`,
              overflowWrap: 'anywhere',
              textAlign: 'center',
              lineHeight: 1,
            }}
          >
            {item.subtitle}
          </Typography>
        </TextsBox>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            // position: 'absolute',
            // bottom: '0.1rem',
            // right: '0.1rem',
          }}
        >
          {GeneratedArrow(item.arrow, item.type, '200px')}
        </Box>
      </Type5Paper>
    );
  }

  if (item.type === 'Label10x10') {
    return (
      <Type4Paper elevation={3} sx={sx}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={item.qrCode} width={310} height={310} alt="" />
          <TextsBox>
            {item?.title ? (
              <Typography
                mb={0.5}
                sx={{
                  color: '#000',
                  fontSize: `${getFontSize(item.type)}px`,
                  overflowWrap: 'anywhere',
                  textAlign: 'center',
                  lineHeight: 1,
                }}
              >
                {item.title}
              </Typography>
            ) : null}
            <Typography
              mb={0}
              sx={{
                color: '#000',
                fontSize: `${getFontSize(item.type)}px`,
                overflowWrap: 'anywhere',
                textAlign: 'center',
                lineHeight: 1,
              }}
            >
              {item.subtitle}
            </Typography>
          </TextsBox>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingRight: 2,
            // position: 'absolute',
            // bottom: '0.1rem',
            // right: '0.1rem',
          }}
        >
          {GeneratedArrow(item.arrow, item.type, '180px')}
        </Box>
      </Type4Paper>
    );
  }

  if (item.type === 'Label5x8') {
    return (
      <Type3Paper elevation={3} sx={sx}>
        {/* <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        > */}
        <img
          src={item.qrCode}
          width={180}
          height={180}
          // width={162}
          // height={162}
          alt=""
          style={{ marginBottom: '6px' }}
        />
        <TextsBox sx={{ marginLeft: '-4px' }}>
          {item?.title ? (
            <Typography
              mb={0.5}
              sx={{
                color: '#000',
                fontSize: `${getFontSize(item.type)}px`,
                overflowWrap: 'anywhere',
                textAlign: 'center',
                lineHeight: 1,
              }}
            >
              {item.title}
            </Typography>
          ) : null}
          <Typography
            mb={0}
            sx={{
              color: '#000',
              fontSize: `${getFontSize(item.type)}px`,
              overflowWrap: 'anywhere',
              textAlign: 'center',
              lineHeight: 1,
            }}
          >
            {item.subtitle}
          </Typography>
        </TextsBox>
        {/* </Box> */}
        <Box
          sx={{
            paddingRight: '2px',
            // position: 'absolute',
            // bottom: '0.1rem',
            // right: '0.1rem',
          }}
        >
          {GeneratedArrow(item.arrow, item.type, item.type)}
        </Box>
      </Type3Paper>
    );
  }

  if (item.type === 'Label3x6') {
    return (
      <Type2Paper sx={sx}>
        <img
          src={item.qrCode}
          width={100}
          height={100}
          alt=""
          style={{ marginBottom: '5px' }}
        />
        <TextsBox>
          {item?.title ? (
            <Typography
              mb={0}
              sx={{
                color: '#000',
                fontSize: `${getFontSize(item.type)}px`,
                overflowWrap: 'anywhere',
                textAlign: 'center',
                lineHeight: 1,
              }}
            >
              {item.title}
            </Typography>
          ) : null}
          {item?.subtitle ? (
            <Typography
              // mt={0.5}
              sx={{
                color: '#000',
                fontSize: `${getFontSize(item.type)}px`,
                overflowWrap: 'anywhere',
                textAlign: 'center',
                lineHeight: 1,
              }}
            >
              {item.subtitle}
            </Typography>
          ) : null}
        </TextsBox>
        <Box sx={{ marginTop: '5px' }}>
          {GeneratedArrow(item.arrow, item.type)}
        </Box>
      </Type2Paper>
    );
  }

  if (item.type === 'Label6x3') {
    return (
      <Type2Paper sx={sx}>
        <img
          src={item.qrCode}
          width={100}
          height={100}
          alt=""
          style={{ marginBottom: '5px' }}
        />
        <TextsBox2>
          {item?.title ? (
            <Typography
              mb={0.5}
              sx={{
                color: '#000',
                fontSize: `${getFontSize(item.type)}px`,
                overflowWrap: 'anywhere',
                textAlign: 'center',
                lineHeight: 1,
              }}
            >
              {item.title}
            </Typography>
          ) : null}
          {item?.subtitle ? (
            <Typography
              // mt={0.5}
              sx={{
                color: '#000',
                fontSize: `${getFontSize(item.type)}px`,
                overflowWrap: 'anywhere',
                textAlign: 'center',
                lineHeight: 1,
              }}
            >
              {item.subtitle}
            </Typography>
          ) : null}
        </TextsBox2>
        <Box sx={{ marginTop: '5px' }}>
          {GeneratedArrow(item.arrow, item.type)}
        </Box>
      </Type2Paper>
    );
  }

  return (
    <Type1Paper ref={ref} elevation={3} sx={sx}>
      <img
        src={item.qrCode}
        width={65}
        height={65}
        alt=""
        style={{ marginBottom: '4px' }}
      />
      <TextsBox>
        {item?.title ? (
          <Typography
            // mb={0.5}
            sx={{
              color: '#000',
              fontSize: item ? `${getFontSize(item.type)}px` : '14px',
              overflowWrap: 'anywhere',
              textAlign: 'center',
              lineHeight: 1,
            }}
          >
            {item.title}
          </Typography>
        ) : null}
        <Typography
          // mb={0}
          sx={{
            color: '#000',
            fontSize: item ? `${getFontSize(item.type)}px` : '14px',
            overflowWrap: 'anywhere',
            textAlign: 'center',
            lineHeight: 1,
          }}
        >
          {item.subtitle}
        </Typography>
      </TextsBox>
      <Box sx={{ marginTop: '4px' }}>
        {GeneratedArrow(item.arrow, item.type)}
      </Box>
    </Type1Paper>
  );
});

const Type1Paper = styled(Paper)({
  background: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0.2rem',
  minHeight: '2cm',
  maxHeight: '2cm',
  width: '5cm',
  maxWidth: '5cm',
  minWidth: '5cm',
  // marginBottom: '2rem',
  borderRadius: '10px',
  paddingRight: '0.3rem',
  paddingLeft: '0.3rem',
});

const Type2Paper = styled(Paper)({
  display: 'flex',
  background: '#fff',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0.1rem',
  minHeight: '3cm',
  maxHeight: '3cm',
  width: '6cm',
  maxWidth: '6cm',
  minWidth: '6cm',
  borderRadius: '10px',
  // marginBottom: '2rem',
  // marginTop: '2rem',
  paddingRight: '0.2rem',
  paddingLeft: '0.4rem',
  // paddingBottom: '0.06rem',
  // boxShadow: 'none',
  // border: 'none',
});

const Type2Container = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0.5rem',
});

const TextsBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

const TextsBox2 = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  transform: 'rotate(270deg)',
  marginBottom: '5px',
});

const Type3Paper = styled(Paper)({
  position: 'relative',
  display: 'flex',
  background: '#fff',
  alignItems: 'center',
  justifyContent: 'space-between',
  // flexDirection: 'column',
  gap: '0.2rem',
  minHeight: '5.5cm',
  maxHeight: '5.5cm',
  minWidth: '8cm',
  maxWidth: '8cm',
  borderRadius: '10px',
  // marginBottom: '2rem',
  paddingRight: '0.1rem',
  paddingLeft: '0.1rem',
  paddingBottom: '0.4rem',
  paddingTop: '0.4rem',
});

const Type3Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5rem',
});

const Type4Paper = styled(Paper)({
  position: 'relative',
  display: 'flex',
  background: '#fff',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0.2rem',
  minHeight: '10cm',
  maxHeight: '10cm',
  minWidth: '10cm',
  maxWidth: '10cm',
  borderRadius: '10px',
  // marginBottom: '2rem',
  paddingRight: '0.1rem',
  paddingLeft: '0.1rem',
  paddingBottom: '0.4rem',
  paddingTop: '0.1rem',
});

const Type5Paper = styled(Paper)({
  position: 'relative',
  display: 'flex',
  background: '#fff',
  alignItems: 'center',
  justifyContent: 'space-around',
  flexDirection: 'column',
  gap: '0.2rem',
  minHeight: '15cm',
  maxHeight: '15cm',
  minWidth: '10cm',
  maxWidth: '10cm',
  borderRadius: '10px',
  // marginBottom: '2rem',
  paddingRight: '0.1rem',
  paddingLeft: '0.1rem',
  paddingBottom: '0.4rem',
  paddingTop: '0.1rem',
});
